var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.977,
    height: 20.977,
    viewBox: "0 0 20.977 20.977",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.483,8.1l-1.612-.35A8.774,8.774,0,0,0,18.352,6.5l.893-1.388a.627.627,0,0,0-.084-.782L16.649,1.816a.627.627,0,0,0-.782-.084l-1.388.893a8.775,8.775,0,0,0-1.251-.519L12.877.493A.627.627,0,0,0,12.264,0H8.712A.627.627,0,0,0,8.1.493l-.35,1.612A8.774,8.774,0,0,0,6.5,2.625L5.11,1.732a.627.627,0,0,0-.782.084L1.816,4.328a.627.627,0,0,0-.084.782L2.625,6.5a8.775,8.775,0,0,0-.519,1.251L.493,8.1A.627.627,0,0,0,0,8.712v3.552a.627.627,0,0,0,.494.612l1.612.35a8.774,8.774,0,0,0,.519,1.251l-.893,1.388a.627.627,0,0,0,.084.782l2.512,2.512a.627.627,0,0,0,.782.084L6.5,18.352a8.775,8.775,0,0,0,1.251.519l.35,1.612a.627.627,0,0,0,.612.494h3.552a.627.627,0,0,0,.612-.494l.35-1.612a8.774,8.774,0,0,0,1.251-.519l1.388.893a.627.627,0,0,0,.782-.084l2.512-2.512a.627.627,0,0,0,.084-.782l-.893-1.388a8.775,8.775,0,0,0,.519-1.251l1.612-.35a.627.627,0,0,0,.494-.612V8.712A.627.627,0,0,0,20.483,8.1Zm-6.234,2.388a3.761,3.761,0,1,1-3.761-3.761A3.765,3.765,0,0,1,14.249,10.488Zm0,0",
    transform: "translate(0 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.eedb1c2bc85de309a756c4861b354f9d.svg";
export { ForwardRef as ReactComponent };